export default function LoadingScreen() {
  return <>Loading...</>;
}
